import { useEffect, useState } from 'react';

export interface BillingPolicy {
  billingEnabled: boolean;
  temporaryOffer: boolean;
  activatedAt: string | null;
}

export function useBillingPolicy(): BillingPolicy | null {
  const [policy, setPolicy] = useState<BillingPolicy | null>(null);
  useEffect(() => {
    const abort = new AbortController();
    void fetch('/api/billing/policy', { credentials: 'omit', cache: 'no-store', signal: abort.signal })
      .then(async response => response.ok ? response.json() as Promise<BillingPolicy> : null)
      .then(value => { if (!abort.signal.aborted && value && typeof value.billingEnabled === 'boolean') setPolicy(value); })
      .catch(() => undefined);
    return () => abort.abort();
  }, []);
  return policy;
}
